
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {label} from './Dictionary.js';

function WifiSetupDialog({open, title, prompt, handleSubmit, handleClose}) {

    return (
        <>
        <Dialog
            open={open}
            fullScreen
            onClose={handleClose}
            PaperProps={{
            component: 'form',
            onSubmit: (event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                const formJson = Object.fromEntries(formData.entries());
                const email = formJson.email;
                console.log(email);

                handleSubmit(email);
                handleClose();
            },
            }}
        >
            <DialogContent>

            <Card sx={{ verticalAlign: "center", maxWidth: 445 }}>
      <CardMedia
        sx={{ height: 340 }}
        image="/wake_button.jpg"
        title="wake"
      />
      <CardContent>
      <Typography gutterBottom variant="h5" component="div">
          {label("ID_RoomeffectSetup")}
        </Typography>
        <DialogContentText>
            
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {label("ID_RoomeffectSetupMessage")}
        </Typography>
        </DialogContentText>
        </CardContent>
    </Card>

            </DialogContent>
            
        </Dialog>
        </>
    );

}

export default WifiSetupDialog;